module.exports = __webpack_public_path__ + "static/media/text_box2.15d3fa7b.png";